// ReachFar catalogue + V43 CAT1 manual; Ling Meng 2026-09-09 confirmed
// shared TCP commands for shared functions. This is documentation support,
// not physical acceptance of a particular device/firmware.
export const PET_MODELS=['V41','V43'];
export const PET_BASE_FEATURES=['position','history','geofence','signal','lowBattery','settings','find','uploadInterval'];
export const PET_COMMANDS=['CR','FIND','UPLOAD'];
const hardware={
 V41:{batteryMah:1300,widthMm:74.1,heightMm:44.5,depthMm:20.7,weightGrams:56.5,voice:'two-way-catalogue',sos:'catalogue',speakingClock:'catalogue',attachment:'collar-buckle'},
 V43:{batteryMah:500,widthMm:52,heightMm:42,depthMm:15,weightGrams:35,voice:'one-way-monitor-manual',sos:'not-used-manual',speakingClock:'not-documented',attachment:'back-clip'},
};
export function petProfile(profile){
 return profile?.protocol==='bracelet'&&profile.kind==='pet'&&PET_MODELS.includes(profile.model)?{model:profile.model,...hardware[profile.model]}:null;
}
export function petFeatureAvailable(profile,id){
 if(!petProfile(profile))return true;
 // Wi-Fi fences have a different slot count in the V43 manual; the existing
 // three-slot wristband screen is not a model-correct implementation.
 return !['device-link','position-wifi-zone','care-measure','care-history','care-schedules','care-thresholds','care-medicine','care-call','care-voice','care-callback','activity-analysis','activity-records','activity-profile','activity-device-steps','device-sos','device-phonebook','device-sms','device-wrist','device-fall','device-sound','device-clock','device-safe-mode','device-language-time','device-power'].includes(id);
}
export function petCommandAllowed(profile,type){
 return !petProfile(profile)||PET_COMMANDS.includes(type);
}
export function petText(text,pet,locale='da-DK'){
 if(!pet)return text;
 return locale==='da-DK'
  ?text.replace(/armbåndets/gi,w=>w[0]==='A'?'Trackerens':'trackerens').replace(/armbåndet/gi,w=>w[0]==='A'?'Trackeren':'trackeren').replace(/armbånd/gi,w=>w[0]==='A'?'Tracker':'tracker')
  :text.replace(/bracelet/gi,w=>w[0]==='B'?'Tracker':'tracker');
}
